import TableExpandedRow from './TableExpandedRow';
export * from './TableExpandedRow';
export default TableExpandedRow;
